import { Dispatch } from "redux";
import { AxiosInstance } from "axios";

import routing from "../../../../routing";
import { showNotification } from "../../../../store/notification/actions";
import { GET_CHOIR, GET_CHOIR_ERROR } from "../types";
import { ICh_ChoirState } from "../models/interfaces";
import { ICh_StateTree } from "../../interfaces";
import { TChoirActionTypes } from "../models";

export default (path: string) => async (dispatch: Dispatch<TChoirActionTypes>, getState: () => ICh_StateTree, api: AxiosInstance) => {
    let choirId = path.slice(`/${routing.choir}/`.length);
    dispatch({
        type: GET_CHOIR,
        payload: null,
    });
    try {
        const { data } = await api.get<ICh_ChoirState>(`/choirs/choir/${choirId}`);
        dispatch({
            type: GET_CHOIR,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: GET_CHOIR_ERROR,
        })
        dispatch(showNotification(error.toString(), "warning"));
    }
};
